export default ( {account, applying, setApplying} ) => {

	const SendApplyAccount = ( account_type ) => {

		setApplying(true);

		fetch(ZapCashierCheckout.ajax, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'application/json, text/plain, */*',
			},
			body: new URLSearchParams({
				action: ZapCashierCheckout.action,
				account: account_type,
				nonce: ZapCashierCheckout.apply_discount_nonce,
			}),
		}).then(() => {

			// Refresh cart/checkout to show coupon has been applied.
			wp.data.dispatch('wc/store/cart').invalidateResolutionForStore();

			// Reset state.
			setApplying(false);
		}).catch(() => {

			// Ensure state is reset even if the request fails.
			setApplying(false);
		});
	}

	return (

		<div className="zap-cashier-checkout-account">
			<p className="zap-cashier-checkout-account-label"><strong>Pay using your {account.account_label}</strong> ({account.account_balance_formatted})</p>
			<button disabled={ applying } type="button" onClick={(event) => { event.preventDefault(); SendApplyAccount(account.account_type) }} className="zapc-checkout-button small">
				Apply { ! applying && (<i className="fa fa-caret-right"></i>)  }

				{ applying && ( <i className="fa fa-spinner fa-spin"></i> ) }

			</button>
		</div>
	);
}